import { Spinner, Text } from "@chakra-ui/react";
import { useGetSteAssetUrlQuery } from "../api/apiSlice";

interface AssetImageProps {
  assetId: string | null;
  alt: string;
  fallbackText?: string;
  w?: string | number;
  h?: string | number;
  borderRadius?: string;
  onImageLoad?: () => void;
}

export function AssetImage({
  assetId,
  alt,
  fallbackText,
  w = "full",
  h = "full",
  borderRadius,
  onImageLoad,
}: AssetImageProps) {
  // We should only query if we have an assetId.
  const shouldSkip = !assetId;

  const { data, isLoading, isError } = useGetSteAssetUrlQuery(
    assetId as string,
    {
      skip: shouldSkip,
    },
  );

  if (!assetId) {
    return (
      <Text fontWeight="bold" fontSize="xl" color="white">
        {fallbackText || "Icon"}
      </Text>
    );
  }

  // Still fetching the presigned URL
  if (isLoading) {
    return <Spinner size="sm" color="white" />;
  }

  // Failed to get presigned URL or no URL returned
  if (isError || !data?.url) {
    return (
      <Text fontWeight="bold" fontSize="xl" color="white">
        {fallbackText || "?"}
      </Text>
    );
  }

  const handleOnLoad = () => {
    onImageLoad?.();
  };

  return (
    <img
      src={data.url}
      alt={alt}
      onLoad={handleOnLoad}
      style={{
        width: typeof w === "number" ? `${w}px` : w,
        height: typeof h === "number" ? `${h}px` : h,
        objectFit: "cover",
        borderRadius: borderRadius,
      }}
    />
  );
}
